<script setup lang="ts">
import { Laptop, Moon, Sun } from '@lucide/vue'
import type { MorningTheme } from '~~/shared/types/morning'

const props = defineProps<{
  theme: MorningTheme
}>()

defineEmits<{
  cycle: []
}>()

const themeMeta = computed(
  () =>
    ({
      auto: { label: 'Apparence automatique', icon: Laptop },
      light: { label: 'Apparence claire', icon: Sun },
      dark: { label: 'Apparence sombre', icon: Moon },
    })[props.theme],
)
</script>

<template>
  <UiIconButton
    variant="chrome"
    class="theme-control"
    type="button"
    :aria-label="`${themeMeta.label}. Changer de thème.`"
    :title="themeMeta.label"
    @click="$emit('cycle')"
  >
    <component
      :is="themeMeta.icon"
      :size="18"
      :stroke-width="1.9"
      aria-hidden="true"
    />
  </UiIconButton>
</template>
